import type { RewardLineKind, RewardLineItem } from "../systems/rewardLineItems.js";
import { RARITY_COLOR } from "./uiTokens.js";
import { PALETTE } from "../themes/palette.js";

/**
 * 보상 종류 → 텍스처 키 (BootScene 로드분 재활용). gold/diamond만 전용 아이콘이고, 나머지
 * (모듈/유물)는 전용 에셋이 없어 의미가 가까운 탭 아이콘으로 대용한다.
 * 전용 PNG가 추가되면 이 Record만 교체하면 된다 (호출부 무변경).
 */
export const REWARD_ICON_KEY: Record<RewardLineKind, string> = {
  gold: "icon_gold",
  diamond: "icon_diamond",
  upgradeStone: "icon_upgrade_stone",
  rebirthPoint: "icon_rebirth_point",
  module: "icon_tab_codex",
  artifact: "icon_tab_relic",
};

/** 라인 아이템 표시 색 — 모듈은 등급색(global.tsv → RARITY_COLOR), 그 외는 기본 밝은 회색. */
export function rewardTint(item: RewardLineItem): string {
  return item.kind === "module" && item.rarity ? RARITY_COLOR[item.rarity] : PALETTE.textPrimary;
}
